import { Component, Inject, Input } from '@angular/core';
import { ConnectionMessage, Severity } from '@vendasta/platform-integrations';
import { AlertTypes, GalaxyAlertModule } from '@vendasta/galaxy/alert';
import { DOCUMENT } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'platform-integration-connection-message',
  imports: [GalaxyAlertModule, TranslateModule],
  templateUrl: './connection-message.component.html',
  styleUrl: './connection-message.component.scss',
})
export class ConnectionMessageComponent {
  @Input() messages!: ConnectionMessage[];
  constructor(@Inject(DOCUMENT) private document: Document) {}

  getAlertType(severity: Severity): AlertTypes {
    switch (severity) {
      case Severity.INFO:
        return 'info';
      case Severity.ERROR:
        return 'error';
      case Severity.WARNING:
        return 'warning';
      default:
        return 'info';
    }
  }

  navigateToAction(ctaUrl: string) {
    if (ctaUrl) {
      this.document.location.href = ctaUrl;
    }
  }
}
